<template>
    <div class="viewData">
        <div class="main">
            <div class="iconList">
                <div class="item bl">
                    <div class="icon">
                        <i class="iconfont icon-renshutongji"></i>
                    </div>
                    <div class="data">
                        <p>总用户参入人数</p>
                        <h4>{{ listObj.user_number | isNull }}</h4>
                    </div>
                </div>
                <div class="item gr">
                    <div class="icon">
                        <i class="iconfont icon-shangpinshuju"></i>
                    </div>
                    <div class="data">
                        <p>商品总销量</p>
                        <h4>{{ listObj.good_number | isNull }}</h4>
                    </div>
                </div>
                <div class="item wa">
                    <div class="icon">
                        <i class="iconfont icon-shengchenghaibao"></i>
                    </div>
                    <div class="data">
                        <p>海报邮寄量</p>
                        <h4>{{ listObj.post_number | isNull }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="main pd0">
              <div class="subtitle">
                    <h3>新品上市</h3>
                </div>
            <div class="pd24">
              
                <div class="form">
                    <el-form ref="form" :model="form" inline>
                        <el-form-item label="联系人：">
                            <el-input
                                v-model="form.name"
                                placeholder="请输入联系人"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：">
                            <el-input
                                v-model="form.phone"
                                placeholder="请输入联系电话"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="时间：">
                            <el-date-picker
                                v-model="form.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="float: right">
                            <el-button type="primary" @click="search"
                                >搜索</el-button
                            >
                            <el-button type="primary" @click="reset"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table">
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        v-loading="tabload"
                    >
                        <el-table-column
                            prop="title"
                            label="活动主题"
                            align="center"
                            width="240px"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="活动时间"
                            align="center"
                        >
                            <template slot-scope="scope">
                                {{
                                    `${scope.row.start_time} ~ ${scope.row.end_time}`
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="connecter_name"
                            label="联系人"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="connecter_phone"
                            label="联系电话"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="expected_number"
                            label="预计投放量"
                            align="center"
                            width="180px"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="操作"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-link
                                    v-if="scope.row.status == 5"
                                    type="primary"
                                    @click="prepayments(scope.row)"
                                    >支付尾款</el-link
                                >
                                <el-link
                                    v-else
                                    type="primary"
                                    @click="detail(scope.row)"
                                    >查看统计数据</el-link
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageList">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <detail ref="detail"></detail>
        <payDialog ref="refPrepayments" @init="getList"></payDialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import payDialog from "@/components/common/payDialog.vue";
import detail from "./detail.vue";

export default {
    components: { detail, payDialog },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            form: {
                name: "",
                phone: "",
                date: [],
            },
            listObj: {
                user_number: 0, //总用户参与数
                good_number: 0, //商品总销量
                post_number: 0, //海报邮寄量
            },
            tableData: [],
        };
    },
    filters: {
        isNull(val) {
            if (val) {
                return val;
            }
            return 0;
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    async created() {
        await this.getTotalList();
        await this.getList(1);
    },
    methods: {
        ...mapActions({
            totalList: "commodity/totalList",
            statisticsList: "commodity/statisticsList",
        }),
        prepayments(row) {
            // console.log(row);
            this.$refs.refPrepayments.dialogVisible = true;
            this.$refs.refPrepayments.statusType = row.status;
            this.$refs.refPrepayments.getInfo(row.id, row.order_activity_id);
        },
        search() {
            this.getList(1);
        },
        reset() {
            (this.form = {
                name: "",
                phone: "",
                date: [],
            }),
                this.getList(1);
        },
        detail(row) {
            this.$refs.detail.dialogVisible = true;
            this.$refs.detail.getDetail(row);
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        getTotalList() {
            this.totalList({ token: this.getToken }).then((res) => {
                if (res.code == 1) {
                    this.listObj = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                connecter_name: this.form.name, //联系人模糊搜索
                connecter_phone: this.form.phone, //联系人电话 精确搜索
                start_time: this.form.date ? this.form.date[0] : null, //开始时间
                end_time: this.form.date ? this.form.date[1] : null, //结束时间
                page: tag == 1 ? 1 : this.page, //当前页码
                size: this.size, //每页显示多少条
            };
            this.statisticsList(opt).then((res) => {
                this.tabload = false;
                if (res.code == 1) {
                    this.tableData = res.data.list;
                    this.total = res.data.count ? res.data.count : 0;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.viewData {
    .main {
        min-width: 1300px;
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        background: #fff;
        margin: 24px;
        padding: 24px;
    }
    .iconList {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
            width: 30%;
            display: flex;
            align-items: center;
            height: 140px;
            padding: 0 40px;
            border-radius: 10px;
            .icon {
                margin-right: 40px;
                i {
                    font-size: 48px;
                    color: #fff;
                }
            }
            .data {
                p {
                    font-size: 20px;
                    color: #fff;
                    margin-bottom: 14px;
                }
                h4 {
                    font-size: 36px;
                    color: #fff;
                }
            }
        }
    }
    .gr {
        background: #67c23a;
    }
    .bl {
        background: #409eff;
    }
    .wa {
        background: #e6a23c;
    }
    .el-table {
        min-height: 400px;
    }
    ::v-deep .el-table__header-wrapper th,
    ::v-deep .el-table__header-wrapper tr {
        background: #fafafa !important;
    }
    ::v-deep .el-date-editor .el-range-separator {
        width: auto;
    }
    .pageList {
        text-align: right;
        margin-top: 20px;
    }
    .pd0 {
        padding: 0;
        .subtitle{
            line-height: 60px;
            padding: 0 24px;
            border-bottom: 2px solid #ECECEC;
        }
    }
    .pd24 {
        padding: 24px;
    }
}
</style>